export const getInitConfig = () => {
  if (window.siteConfig) {
    return window.siteConfig
  } else {
    let domain = localStorage.getItem('loginType');
    let config = {
      loginBack: 'assets/images/bg.jpg',
      loginText: '医学影像高校教育平台',
      ico: 'static/images/favicon.ico',
      title: '医学影像高校教育平台',
      showDownBtn: true,
      smalllogoUrl: 'static/images/logo-small.png',
      logoUrl: 'static/images/logo.png',
      logoText: '医学影像高校教育平台'
    };
    let xhr = new XMLHttpRequest();
    // xhr.open('GET', '/siteConfig/' + domain, false);
    xhr.open('GET', 'static/siteConfig/' + domain, false);
    xhr.send(null);
    if (xhr.status === 200) {
      try {
        let siteConfig = JSON.parse(xhr.responseText)
        if (siteConfig) {
          config = Object.assign(config, siteConfig)
        }
      } catch (error) {
        // console.log(error);
      }
    } else {}
    window.siteConfig = config;
    return config;
  }
};



// WEBPACK FOOTER //
// ./src/config/config.js